module.exports = __webpack_public_path__ + "static/media/icon_nav_product.4699c558.svg";